import styles from './VinBadge.module.scss';

function CarIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M5 17h14M5 17a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1l2-3h8l2 3h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2" />
            <circle cx="7.5" cy="14.5" r="1.5" />
            <circle cx="16.5" cy="14.5" r="1.5" />
        </svg>
    );
}

export default function VinBadge({ vin, label = 'VIN' }) {
    if (!vin) return null;

    return (
        <div className={styles.badge}>
            <CarIcon className={styles.icon} />
            <span className={styles.label}>{label}</span>
            <span className={styles.code}>{vin}</span>
        </div>
    );
}
